module.exports = __webpack_public_path__ + "static/media/S3N8-3.39e8345f.svg";